import { useMutation } from "@tanstack/react-query";
import { apiClient } from "@/api/client";

export type SyncFeedbackInput = {
  sensor_kit_serial_number: string;
  message: string;
  name?: string;
  phone_number?: string;
  email?: string;
};

export type SyncFeedbackResponse = {
  id: number;
  sensor_kit_serial_number: string;
  message: string;
  name: string;
  phone_number: string;
  email: string;
  created_at: string;
};

export const useSyncFeedback = () => {
  return useMutation({
    mutationFn: async (data: SyncFeedbackInput) => {
      const res = await apiClient.post<SyncFeedbackResponse>('/sync-feedback/', data);
      return res.data;
    },
  });
};
